function getApiURL() {
	const theHostname = (window.location.hostname === 'localhost')
		? 'localhost:4000'
		: window.location.hostname

	return `http://${theHostname}/api`
}


export default {
	getApiURL
}



// WEBPACK FOOTER //
// ./src/helper/api.js